import { ConnectedRouter } from 'connected-react-router';
import { getData } from 'modules/auth/guards';
import { ScrollToTop } from 'modules/common/components';
import history from 'store/history';
import { loginRoutes } from 'modules/v2/login/routes';
import { routes as onboardRoutes } from 'modules/onboard/routes';
import { routes as landingPageRoutes } from 'modules/landingPages/routes';
import { routes as regularRoutes } from 'modules/v2/routes';
import { routes as DraftRoutes } from 'modules/v2/draft/routes';
import { deleteCookie, getCookie } from 'v2/common/utils/cookie';
import { useCreateOnboarding } from 'modules/api/digitalServices/hooks/use-onboarding-completion-status.hook';
import Renderer from './Renderer';
import routes from './routes';

const Router = () => {
  const { token, userData, refreshToken, admin } = getData();
  const isLogged = !!token && !!userData && !!refreshToken && !admin;

  const onboardRedirectUrl = getCookie('onboardRedirectUrl');
  const email = getCookie('onboardingEmail');
  useCreateOnboarding(email, Boolean(email));

  if (onboardRedirectUrl && email) {
    deleteCookie('onboardRedirectUrl');
    deleteCookie('onboardingEmail');
    window.location.href = onboardRedirectUrl;
    return null;
  }

  if (!isLogged) {
    return (
      <ConnectedRouter history={history}>
        <Renderer
          config={[
            ...loginRoutes,
            ...onboardRoutes,
            ...landingPageRoutes,
            ...regularRoutes,
            ...DraftRoutes,
          ]}
        />
      </ConnectedRouter>
    );
  }

  return (
    <ConnectedRouter history={history}>
      <ScrollToTop>
        <Renderer config={routes} />
      </ScrollToTop>
    </ConnectedRouter>
  );
};

export default Router;
